import { createContainer } from "unstated-next";
import { useLocalStorage } from "react-use";
import { useCallback } from "react";
import { Metadata } from "grpc-web";
import pickBy from "lodash/pickBy";
import identity from "lodash/identity";
import { PARTNER_ID } from "@/env";
import { getRemoteConfigValue } from "@/modules/app/useRemoteConfig";

export const getServiceMetaFromToken = (token?: string | null) => {
  const m: Metadata = {};

  if (!token) {
    return m;
  }
  return {
    ...m,
    ...pickBy({ partnerId: PARTNER_ID }, identity),
    Authorization: `Bearer ${token}`,
  };
};

const TOKEN_STORAGE_KEY = "authtoken__";

const useAuthState_ = (
  initState: { token?: string | null } = { token: window.guestToken }
) => {
  const [token, setToken] = useLocalStorage<string | null>(
    TOKEN_STORAGE_KEY,
    initState.token
  );

  const getServiceMeta = useCallback(() => {
    return {
      ...getServiceMetaFromToken(token),
      ...getRemoteConfigValue("extraHeaders", {}),
    };
  }, [token]);

  const state = {
    token,
    get serviceMetaData() {
      return getServiceMeta();
    },
    get restHeaders() {
      return getServiceMeta();
    },
  };
  const actions = { setToken };

  return [state, actions] as [typeof state, typeof actions];
};

const AuthState = createContainer(useAuthState_);

export const useAuthState = () => AuthState.useContainer();

AuthState.Provider.displayName = "AuthStateProvider";

const AuthStateProvider = AuthState.Provider;

export default AuthStateProvider;
